import uniqid from 'uniqid'
import { isPlainObject } from 'lodash'
import deepMerge from 'deepmerge'

/* const returning = ({ items, root, fields }) =>
  items.map(item => ({
    ...deepMerge(
      Object
      .fromEntries(
        [
          ...fields.filter(field => !isPlainObject(field)),
          ...Object.keys(fields.find(isPlainObject))
        ]
        .map(
          field =>
            [
              field,
              null
            ]
        )
      ),
      item
    ),
    id: `insert_${root}_${i++}`,
    __typename: root
  }))
 */

const returning = ({ items, root, fields }) =>
  items.map(item => ({
    ...item,
    id: `optimistic-ui-${uniqid()}`
  }))

export default ({ root, items, fields }) => ({
  [`insert_${root}`]: {
    returning: returning({ items, root, fields }),
    __typename: `${root}_mutation_response`
  }
})
